<!-- 
ALERTAS

    <alert type="info" title="Teste de aviso" text="Nenhum registro foi encontrado para o período."></alert>

    <alert v-if="!nfList.length" type="norecord"></alert>


    //mensagens de erro
    <alert v-if="errmessages.length > 0" type="error" title="Erro no envio do arquivo de retorno" :messages="errmessages"></alert>


TIPOS: info, warning, error, norecord

-->


<template>
    <div class="row nb-margin-topbottom">
        <div v-if="type!=='norecord'" class="col-md-12 col-12">
            <div v-show="show" class="nb-alert" :class="type" role="alert">
                <button v-if="close" type="button" class="close" @click="toggleAlert"><span aria-hidden="true">&times;</span></button>
                <p v-if="title" class="nb-alert-title"><strong>{{ title }}</strong></p>
                <span v-if="!messages">{{ text }}</span>
                <p v-for="(text, index) in messages" :key="index">
                  <span v-if="text.message">{{ text.message }}</span>              
                  <span v-else>{{ text }}</span>
                  <span v-if="text.codpart">
                    <a href="#" data-toggle="tooltip" data-placement="top" title="Alterar"
                        @click="clickEdit('part', text.codpart)">
                            <i class="fa fa-pencil fa-fw"></i>
                            Editar Cliente
                    </a>
                  </span>              
                </p>
            </div>
        </div>
        <div v-if="type==='norecord'" class="col-md-12 col-12">
            <div v-show="show" class="nb-alert warning" role="alert">
                <button v-if="close" type="button" class="close" @click="toggleAlert"><span aria-hidden="true">&times;</span></button>
                <span>Nenhum registro foi encontrado.</span>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'alert',

    props: {
      title: { type: String },
      text: { type: String },
      type: { type: String },
      close: { type: Boolean, default: true },
      messages: { type: Array },
    },

    data () {
        return {
            show: true,
        }
    },

    methods: {
        toggleAlert() {
            this.show = false
        },

        clickEdit(tipo, codpart){
          this.$emit('edit', tipo, codpart)
        },
    },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/alert.vue